/* ==========================================================================
   Jabree — K59 interactive sizing widget engine (jab-k59-sizing.js)
   Drag-to-rotate model video scrubber + model/size/length selectors + chart.
   Single responsive instance, lives inside the jab-pdp size-guide modal.
   Videos load lazily (preload=none) the first time the widget becomes visible
   (i.e. when the size-guide popup opens). Mobile pulls compressed renditions
   from /mobile/ with auto-fallback to full-res. Vanilla JS, no deps.
   ========================================================================== */
(function () {
  'use strict';

  var ORIGIN = 'https://pub-092d13100b564d1bbe161cda9bd65408.r2.dev/';
  function isMobileNow() { return window.matchMedia('(max-width: 760px)').matches; }
  function mobileURL(file) { return ORIGIN + 'mobile/' + file; }
  function fullURL(file) { return ORIGIN + file; }
  function preferredURL(file) { return isMobileNow() ? mobileURL(file) : fullURL(file); }

  var VIDEOS = {
    'chris-m-reg': 'chris_medium_regular.mp4', 'chris-m-long': 'chris_medium_long.mp4',
    'chris-l-reg': 'chris_large_regular.mp4',  'chris-l-long': 'chris_large_long.mp4',
    'tito-s-reg':  'tito_small_regular.mp4',   'tito-s-long':  'tito_small_long.mp4',
    'tito-m-reg':  'tito_medium_regular.mp4',  'tito-m-long':  'tito_medium_long.mp4',
    'tj-l-reg':    'tj_large_regular.mp4',     'tj-l-long':    'tj_large_long.mp4',
    'tj-xl-reg':   'tj_xl_regular.mp4',        'tj-xl-long':   'tj_xl_long.mp4'
  };
  var CHART = [
    { size:'S',  waist:'28-31"', reg:'18"', long:'21.5"' },
    { size:'M',  waist:'30-33"', reg:'19"', long:'22.5"' },
    { size:'L',  waist:'32-35"', reg:'20"', long:'23.5"' },
    { size:'XL', waist:'34-37"', reg:'21"', long:'24.5"' }
  ];
  var MODEL_SIZES = { tito:['s','m'], chris:['m','l'], tj:['l','xl'] };
  var SIZE_LABEL  = { s:'S', m:'M', l:'L', xl:'XL' };
  var SIZE_ROW    = { s:0, m:1, l:2, xl:3 };

  function renderChart(tbody) {
    tbody.innerHTML = '';
    CHART.forEach(function (row, i) {
      var r = document.createElement('div');
      r.className = 'jk-sz-row'; r.setAttribute('data-row', i);
      r.innerHTML = '<span class="td-size">' + row.size + '</span>'
        + '<span class="td-waist">' + row.waist + '</span>'
        + '<span class="td-out td-out-reg">' + row.reg + '</span>'
        + '<span class="td-out td-out-long">' + row.long + '</span>';
      tbody.appendChild(r);
    });
  }
  /* the ONLY thing that moves on select: the gray box on the active size's
     Regular OR Long outseam cell. */
  function highlightChart(tbody, currentSize, isLong) {
    var hl = tbody.querySelector('.td-out.is-hl'); if (hl) hl.classList.remove('is-hl');
    var row = tbody.querySelectorAll('.jk-sz-row')[SIZE_ROW[currentSize]];
    if (!row) return;
    var cell = row.querySelector(isLong ? '.td-out-long' : '.td-out-reg');
    if (cell) cell.classList.add('is-hl');
  }
  /* size dropdown carries length: value "m|reg" / "m|long", label "M" / "M-Long" */
  function sizeLenOptions(model) {
    var out = [];
    MODEL_SIZES[model].forEach(function (s) {
      out.push({ val: s + '|reg',  label: SIZE_LABEL[s] });
      out.push({ val: s + '|long', label: SIZE_LABEL[s] + '-Long' });
    });
    return out;
  }
  function populateSizeLength(sel, model, current, keep) {
    var opts = sizeLenOptions(model); sel.innerHTML = '';
    opts.forEach(function (o) { var el = document.createElement('option'); el.value = o.val; el.textContent = o.label; sel.appendChild(el); });
    var vals = opts.map(function (o) { return o.val; });
    if (keep && vals.indexOf(current) !== -1) { sel.value = current; return current; }
    sel.value = vals[0]; return vals[0];
  }
  function parseSizeLen(v) { var p = (v || '').split('|'); return { size: p[0], isLong: p[1] === 'long' }; }

  /* rAF-coalesced, seek-guarded scrub loader (one reused <video>) */
  function makeSizingLoader(viewerEl, loadEl, barEl) {
    var video = document.createElement('video');
    video.muted = true; video.playsInline = true;
    video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
    video.setAttribute('disableRemotePlayback', ''); video.preload = 'none';
    video.classList.add('active');
    viewerEl.appendChild(video);

    var token = 0, duration = 0, shown = false, seeking = false;
    var targetTime = null, appliedTime = null, rafQueued = false;
    function updateBar() { if (duration) barEl.style.width = (video.currentTime / duration * 100) + '%'; }
    function flushSeek() {
      if (!duration || seeking) return;
      if (targetTime === null || targetTime === appliedTime) return;
      seeking = true; appliedTime = targetTime; video.currentTime = targetTime;
    }
    video.addEventListener('seeked', function () {
      seeking = false;
      if (!shown) { shown = true; loadEl.classList.add('hidden'); }
      updateBar();
      if (targetTime !== null && targetTime !== appliedTime) flushSeek();
    });
    return {
      load: function (key) {
        var file = VIDEOS[key];
        var myToken = ++token, triedFull = false;
        duration = 0; shown = false; seeking = false; targetTime = null; appliedTime = null;
        barEl.style.width = '0%';
        if (!file) { loadEl.classList.remove('hidden'); loadEl.textContent = 'Coming soon'; video.pause(); video.removeAttribute('src'); video.load(); return; }
        loadEl.classList.remove('hidden'); loadEl.textContent = 'Loading…';
        video.pause();
        video.onloadedmetadata = function () {
          if (myToken !== token) return;
          duration = video.duration || 0;
          if (duration) { seeking = true; appliedTime = duration * 0.5; video.currentTime = appliedTime; }
        };
        video.onerror = function () {
          if (myToken !== token) return;
          if (isMobileNow() && !triedFull) { triedFull = true; loadEl.textContent = 'Loading…'; video.src = fullURL(file); video.load(); return; }
          loadEl.textContent = 'Coming soon';
        };
        video.src = preferredURL(file); video.load();
      },
      scrub: function (t) {
        if (!duration) return;
        targetTime = Math.max(0, Math.min(duration, t));
        if (!rafQueued) { rafQueued = true; requestAnimationFrame(function () { rafQueued = false; flushSeek(); }); }
      },
      getDuration: function () { return duration; },
      ready: function () { return duration > 0 && shown; },
      getTime: function () { return video.currentTime; }
    };
  }

  function initWidget(root) {
    if (root.__jkSz) return;
    root.__jkSz = 1;
    var $ = function (s) { return root.querySelector(s); };

    var viewer = $('[data-sz-viewer]');
    var loadEl = $('[data-sz-loading]');
    var barEl  = $('[data-sz-bar]');
    var bodyEl = $('[data-sz-body]');
    var modelSel = $('[data-sz-model]');
    var sizeSel  = $('[data-sz-size]');

    var model = 'chris', sizeVal = 'm|reg', size = 'm', isLong = false, loaded = false;
    var loader = makeSizingLoader(viewer, loadEl, barEl);

    function apply() { var pl = parseSizeLen(sizeVal); size = pl.size; isLong = pl.isLong; }
    function key() { return model + '-' + size + '-' + (isLong ? 'long' : 'reg'); }
    function loadVideo() { loaded = true; loader.load(key()); }

    modelSel.addEventListener('change', function () {
      model = modelSel.value;
      sizeVal = populateSizeLength(sizeSel, model, sizeVal, true);
      apply(); highlightChart(bodyEl, size, isLong);
      if (loaded) loader.load(key());
    });
    sizeSel.addEventListener('change', function () {
      sizeVal = sizeSel.value; apply(); highlightChart(bodyEl, size, isLong);
      if (loaded) loader.load(key());
    });

    /* drag to scrub */
    var dragging = false, mouseStartX = 0, mouseStartTime = 0;
    var touchStartX = 0, touchStartY = 0, touchStartTime = 0, touchLocked = false;
    viewer.addEventListener('mousedown', function (e) { if (!loader.ready()) return; dragging = true; mouseStartX = e.clientX; mouseStartTime = loader.getTime(); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { if (!dragging) return; loader.scrub(mouseStartTime + ((e.clientX - mouseStartX) / 280) * loader.getDuration()); });
    window.addEventListener('mouseup', function () { dragging = false; });
    viewer.addEventListener('touchstart', function (e) { if (!loader.ready()) return; touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; touchStartTime = loader.getTime(); dragging = false; touchLocked = false; }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (!loader.ready()) return;
      var dx = e.touches[0].clientX - touchStartX, dy = e.touches[0].clientY - touchStartY;
      if (!dragging && !touchLocked) { if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) { dragging = true; } else if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) { touchLocked = true; return; } else { return; } }
      if (touchLocked) return;
      e.preventDefault(); loader.scrub(touchStartTime + (dx / 280) * loader.getDuration());
    }, { passive: false });
    window.addEventListener('touchend', function () { dragging = false; touchLocked = false; });

    /* init chart immediately; load video only when visible (modal opens) */
    sizeVal = populateSizeLength(sizeSel, model, sizeVal, false);
    apply();
    renderChart(bodyEl); highlightChart(bodyEl, size, isLong);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && !loaded) loadVideo(); });
      }, { threshold: 0.05 });
      io.observe(viewer);
    } else {
      loadVideo();
    }
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-jk-sz]')).forEach(initWidget); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
